module.exports = __webpack_public_path__ + "media/apps/gif-ios-56-d1c0588f.gif";